import React from "react";
import { Link } from "react-router-dom";
import { FaUser, FaRegClock } from "react-icons/fa";
import Moment from "react-moment";

function PostDetailHeader({ groupName, slug, groupId, postData }) {
    return (
        <div className="mb-2">
            {/* Breadcrumb */}
            <div className="flex items-center gap-1 text-white font-semibold text-[16px]">
                <Link to="/group" className="text-white no-underline hover:no-underline">
                    Group
                </Link>
                <span className="mx-1">&#62;</span>
                <Link to={`/group/${slug}/${groupId}`} className="text-white no-underline hover:no-underline">
                    {groupName || ""}
                </Link>
            </div>

            {/* Title */}
            <h1 className="font-bold text-[20px] text-white mt-1 mb-1 break-words">
                {postData?.Title || ""}
            </h1>

            {/* Author & Date */}
            <div className="flex items-center gap-3 text-white text-[16px] mb-2">
                <FaUser className="inline" />
                <span>{postData?.UserFullName || postData?.UserName || ""}</span>
                <FaRegClock className="inline ml-4" />
                <span>
                    {postData?.UpdatePostAt ? (
                        <Moment format="DD/MM/YY">{`${postData?.UpdatePostAt}+0700`}</Moment>
                    ) : null}
                </span>
            </div>
        </div>
    );
}

export default PostDetailHeader;

